<script lang="ts">
	let className = '';
	export { className as class };
</script>

<div class="spinner {className}">
	<div class="spinner__container">
		<svg class="spinner__circle" viewBox="0 0 50 50" aria-hidden="true"
			><circle class="path" cx="25" cy="25" r="22.5" fill="none" stroke-width="4"></circle></svg
		>
		<svg class="spinner__circle-background" viewBox="0 0 50 50" aria-hidden="true"
			><circle class="path" cx="25" cy="25" r="22.5" fill="none" stroke-width="4"></circle></svg
		>
	</div>
</div>

<style lang="postcss">
	.spinner__circle {
		animation: 2s linear 0s infinite normal none running rotate;
		z-index: 2;
		position: absolute;
		width: 1.5rem;
		height: 1.5rem;
	}

	.spinner__circle-background {
		animation: 2s linear 0s infinite normal none running rotate;
		z-index: 2;
		width: 1.5rem;
		height: 1.5rem;
	}

	.spinner__circle .path {
		@apply text-magenta stroke-current;
		animation: 1.5s ease-in-out 0s infinite normal none running dash;
	}

	@keyframes rotate {
		100% {
			transform: rotate(360deg);
		}
	}

	@keyframes dash {
		0% {
			stroke-dasharray: 1, 150;
			stroke-dashoffset: 0;
		}
		50% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -35;
		}
		100% {
			stroke-dasharray: 90, 150;
			stroke-dashoffset: -124;
		}
	}
</style>
